import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import BulkResume from "./BulkResume";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";

BulkProfileResume.propTypes = {};

function BulkProfileResume(props) {
  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  return (
    <>
      <InstituteMobileHeader handleMobile={handleMobile} />
      <InstituteHeader clname="manageBatch" handleMobile={handleMobile} />
      {/* <LoginHeader clname="act1" handleMobile={handleMobile} /> */}
      <div className="pt-70">
        <BulkResume />
        {/* <Footer /> */}
        <Gotop />
      </div>
    </>
  );
}

export default BulkProfileResume;
